export enum ProfileActionErrorCode {
    RULES_RELATED_PROFILE_DELETE = '28730',
    RULES_RELATED_PROFILE_HOLD = '28731',
    PROFILES_UNIQUE_FIELDS_ERROR = '28829'
}
